"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventContext = void 0;
class EventContext {
  constructor(contextId) {
    this.contextId = contextId;
  }
}
exports.EventContext = EventContext;